import remote from "../../../../services/remote";
import {editUniteSuccess, editUniteFailure, addAvailableUnitsSuccess, addAvailableUnitsFailure, getAvailableUnitsSuccess, getAvailableUnitsFailure, getAvailableUnitsListSuccess, getAvailableUnitsListFailure, deleteUniteSuccess, deleteUniteFailure} from "./actions";
import {ADD_AVAILABLE_UNITS_REQUEST, GET_AVAILABLE_UNITS_REQUEST, GET_AVAILABLE_UNITS_LIST_REQUEST, REMOVE_AVAILABLE_UNITS_REQUEST, EDIT_AVAILABLE_UNITS_REQUEST} from "./constants";
import {call, put, takeLatest} from "redux-saga/effects";
import SentryManager from "../../../../monitoring/Sentry";

function* addAvailableUnits (action) {
    try {
        const response = yield call(remote, {
            route: '/admin/available-units/add-available-units',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(addAvailableUnitsSuccess(response.data));
        } else {
            yield put(addAvailableUnitsFailure(response.error));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* getAvailableUnits (action) {
    try {
        const response = yield call(remote, {
            route: '/admin/available-units/get-available-units',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(getAvailableUnitsSuccess(response.data));
        } else {
            yield put(getAvailableUnitsFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* getAvailableUnitsList (action) {
    try {
        const response = yield call(remote, {
            route: '/admin/available-units/get-available-units-list',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(getAvailableUnitsListSuccess(response.data));
        } else {
            yield put(getAvailableUnitsListFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* deleteAvailableUnite (action) {
    try {
        const response = yield call(remote, {
            route: '/admin/available-units/remove-available-unite',
            method: 'delete',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(deleteUniteSuccess(response.data));
        } else {
            yield put(deleteUniteFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* editAvailableUnite (action) {
    try {
        const response = yield call(remote, {
            route: '/admin/available-units/edit-available-unite',
            method: 'put',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(editUniteSuccess(response.data));
        } else {
            yield put(editUniteFailure(response.error));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

export default function* watchAdminAvailableUnits() {
    yield takeLatest(ADD_AVAILABLE_UNITS_REQUEST , addAvailableUnits);
    yield takeLatest(GET_AVAILABLE_UNITS_REQUEST , getAvailableUnits);
    yield takeLatest(GET_AVAILABLE_UNITS_LIST_REQUEST , getAvailableUnitsList);
    yield takeLatest(REMOVE_AVAILABLE_UNITS_REQUEST , deleteAvailableUnite);
    yield takeLatest(EDIT_AVAILABLE_UNITS_REQUEST , editAvailableUnite);
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/AvailableUnits/saga.js